import mixpanel from "mixpanel-browser";

let enabled = false;
let initialized = false;

// export const initMixpanel = (isEnabled) => {
//   enabled = isEnabled;
//   console.log("enabled========",enabled);

//   if (!enabled || initialized) return;

//   mixpanel.init("d63ca0fd969c18e288ed6487129d20b7", {
//     autocapture: true,
//     record_sessions_percent: 100,
//   });

//   initialized = true;
// };

export const initMixpanel = (isEnabled, mixpanelKey) => {
  enabled = isEnabled;
  console.log("Mixpanel enabled ========", enabled);

  // If not enabled, already initialized, or key is missing, bail out
  if (!enabled || initialized || !mixpanelKey) {
    if (enabled && !mixpanelKey) {
      console.warn("Mixpanel execution halted: No tracking key provided.");
    }
    return;
  }

  mixpanel.init(mixpanelKey, {
    autocapture: true,
    record_sessions_percent: 100,
  });

  initialized = true;
};

const noop = () => {};

const mixpanelWrapper = {
  track: (...args) => {
    if (!enabled) return noop();
    return mixpanel.track(...args);
  },

  track_pageview: (...args) => {
    if (!enabled) return noop();
    return mixpanel.track_pageview(...args);
  },

  identify: (...args) => {
    if (!enabled) return noop();
    return mixpanel.identify(...args);
  },

  people: {
    set: (...args) => {
      if (!enabled) return noop();
      return mixpanel.people.set(...args);
    },
  },
};

export default mixpanelWrapper;